import logo from '../logo-black.svg';
import React from "react";
import { Link, useNavigate } from "react-router-dom";

import LanguageSwitcher from './LanguageSwitcher';

const Navbar = ({ user }) => {
    const navigate = useNavigate();

    function handleLoginClick() {
      navigate("/login");
    }

    return (
        <div>
            {/* <Link to="/">Home</Link> | <Link to="/login">Login</Link> |{" "}
            <Link to="/user">User</Link> */}
            <nav className="shadow navbar navbar-expand-lg navbar-light">
                <div className="container">
                    {/* Brand Name */}
                    <a className="navbar-brand fw-bold fs-3" href="/">
                        {/* <img src={logo} alt="Logo" width="32" style={{ padding: "0 4px 8px 0"}} /> */}
                        OPURL
                    </a>

                    {/* Responsive Toggle */}
                    {/* <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button> */}

                    {/* Navbar Content */}
                    {/* <div className="collapse navbar-collapse" id="navbarNav">
                        <div className="ms-auto">
                            <button className="btn btn-primary" type="button" onClick={handleLoginClick}>
                            Login
                            </button>
                        </div>
                    </div> */}

                    <LanguageSwitcher/>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;